import React from "react";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import Table from "../../../../components/Table";
import Pagination from "../../../../components/Pagination";
import FilterButtons from "../../../../components/universal-filter-tabs.jsx";
import StockTransferModal from "./StockTransferModal";
import styles from "../css/stockTransfer.module.css";

export default function StockTransferContent({
  roleId,
  activeSegment,
  setActiveSegment,
  visibleColumns,
  pageData,
  currentPage,
  totalPages,
  setCurrentPage,
  isModalOpen,
  selectedRow,
  isApproved,
  onCloseModal,
  onAddToInventory,
}) {
  return (
    <div className={`${styles.wrapper} ${isModalOpen ? styles.wrapperLocked : ""}`}>
      <Navbar />
      <div className={styles.dashboardLayout}>
        <main className={styles.main}>
          <div className={`${styles.container} ${isModalOpen ? styles.containerLocked : ""}`}>
            <div className={styles.headerRow}></div>
            {roleId !== 6 && (
              <FilterButtons
                buttons={["Dispensary", "Front Shop", "OTC", "Clinic"]}
                activeButton={activeSegment}
                onButtonClick={setActiveSegment}
                className={styles.segmentTabs}
              />
            )}

            <Table columns={visibleColumns} data={pageData} />
            <div className={styles.paginationContainer}>
              <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
            </div>

            {isModalOpen && selectedRow && (
              <StockTransferModal
                activeSegment={activeSegment}
                selectedRow={selectedRow}
                isApproved={isApproved}
                onClose={onCloseModal}
                onAddToInventory={onAddToInventory}
              />
            )}
          </div>
        </main>
      </div>
      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
